module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 1194
// module chunks = 6